import { type FormatFn } from './Format.types'

export const NumericFormatter: FormatFn<number> = (value) => {
  return value.toLocaleString()
}
